import { Injectable } from '@angular/core';
import rusha from 'rusha';

@Injectable({ providedIn: 'root' })
export class HashService {
	async readSHA1(file: Blob) {
		const sha1 = rusha.createHash();
		const fileSize = file.size;
		// 4 * 1024 * 1024
		const chunkSize = 4_194_304;
		let offset = 0;
		do {
			const newOffset = offset + chunkSize;
			const fileSlice = file.slice(offset, newOffset);
			offset = newOffset;
			const res = await fileSlice.arrayBuffer();
			sha1.update(res);
		} while (offset < fileSize);
		return sha1.digest('hex');
	}
}
